import { generateJSON } from '@tiptap/html';
import { factoryExtensions } from '../components/Editor/useExtensions';
import { SchemaVersion } from '../server/types';
export const fromWriterHtml = (html, extensionConfig)=>{
    const extensions = factoryExtensions(extensionConfig, {});
    return {
        version: SchemaVersion.V1,
        document: generateJSON(html, extensions)
    };
};

//# sourceMappingURL=fromWriterHtml.js.map